import { useState, useEffect } from 'react';

export function useVisitFilters() {
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedRating, setSelectedRating] = useState('Todas as avaliações');
  const [showRatingDropdown, setShowRatingDropdown] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('Todos');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [showItemsDropdown, setShowItemsDropdown] = useState(false);


  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [mobileStatus, setMobileStatus] = useState('Todos');
  const [showMobileRatingDropdown, setShowMobileRatingDropdown] = useState(false);
  const [mobileVisitDate, setMobileVisitDate] = useState('');
  const [mobileRatingSlider, setMobileRatingSlider] = useState(0);
  const [showMobileMotiveModal, setShowMobileMotiveModal] = useState(false);
  const [selectedMotives, setSelectedMotives] = useState([]);
  const [tempSelectedMotives, setTempSelectedMotives] = useState([]);
  const [showMotivesList, setShowMotivesList] = useState(false);

  const [isConsultantDataExpanded, setIsConsultantDataExpanded] = useState(true);
  const [isVisitsHistoryExpanded, setIsVisitsHistoryExpanded] = useState(true);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedRating, selectedStatus, selectedDate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('[data-rating-dropdown]')) return;
      setShowRatingDropdown(false);
    };

    if (showRatingDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showRatingDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('[data-items-dropdown]')) return;
      setShowItemsDropdown(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showItemsDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('[data-mobile-rating-dropdown]')) return;
      setShowMobileRatingDropdown(false);
    };

    if (showMobileRatingDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMobileRatingDropdown]);

  return {
    selectedDate, setSelectedDate,
    selectedRating, setSelectedRating,
    showRatingDropdown, setShowRatingDropdown,
    selectedStatus, setSelectedStatus,
    currentPage, setCurrentPage,
    itemsPerPage, setItemsPerPage,
    showItemsDropdown, setShowItemsDropdown,
    showMobileFilters, setShowMobileFilters,
    mobileStatus, setMobileStatus,
    showMobileRatingDropdown, setShowMobileRatingDropdown,
    mobileVisitDate, setMobileVisitDate,
    mobileRatingSlider, setMobileRatingSlider,
    showMobileMotiveModal, setShowMobileMotiveModal,
    selectedMotives, setSelectedMotives,
    tempSelectedMotives, setTempSelectedMotives,
    showMotivesList, setShowMotivesList,
    isConsultantDataExpanded, setIsConsultantDataExpanded,
    isVisitsHistoryExpanded, setIsVisitsHistoryExpanded,
  };
}
